// imports
import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../constants';

// interfaces / types / consts
interface ProtectedProps {
  origin: string;
  outlet: JSX.Element;
  isAuthenticated: boolean;
}

// exports
export default function Protected(props: ProtectedProps): JSX.Element {
  const {
    isAuthenticated, outlet, origin
  } = props;
  if (isAuthenticated) { return outlet; }
  return <Navigate replace to={ROUTES.HOME} state={origin} />;
}
